import { BigNumber } from "ethers";
import useAssets from "hooks/useAssets";
import useHive from "hooks/useHive";
import useVesting from "hooks/useVesting";
import { useMemo } from "react";

const useHoneyOwnedTotal = () => {
  const { honeyBalance } = useAssets();
  const { vestingAmountInJarsRemainingSum } = useVesting();
  const { hiveBalanceInTokensSum } = useHive();

  return useMemo(() => {
    const zero = BigNumber.from("0");

    return (honeyBalance || zero)
      .add(vestingAmountInJarsRemainingSum || zero)
      .add(hiveBalanceInTokensSum || zero);
  }, [honeyBalance, hiveBalanceInTokensSum, vestingAmountInJarsRemainingSum]);
};

export default useHoneyOwnedTotal;
